import React from 'react';
import InitialMotion from '../../marketingRendering/InitialMotion';

import SectionHeader from './SectionHeader';

function FAQSection({ id, className = '', label, title, description, items }) {
  return (
    <section className={['faq', className].filter(Boolean).join(' ')} id={id}>
      <div className="container">
        <SectionHeader label={label} title={title} description={description} />
        <div className="faq-wrap">
          {items.map((item) => (
            <InitialMotion as="details" motionKey={`faq-${item.q}`} key={item.q}>
              <summary>{item.q}</summary>
              <div className="faq-a">{item.a}</div>
            </InitialMotion>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FAQSection;
